import { render, staticRenderFns } from "./ModalStageInfo.vue?vue&type=template&id=06500c7f&"
import script from "./ModalStageInfo.vue?vue&type=script&lang=js&"
export * from "./ModalStageInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalStageInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports